import * as React from 'react';
import { PrimaryButton } from "../../global/components/buttons/primary-button";

interface IProps {
    addSearchFieldLabel: string;
    searchLabel: string;

    onAddSearchField: (e: React.MouseEvent<HTMLElement>) => void;
    onSearch: () => void;
}

interface IState {

}

export class SearchButtons extends React.Component<IProps, IState> {

    render() {
        const {
            addSearchFieldLabel,
            searchLabel,
            onAddSearchField,
            onSearch
        } = this.props;

        return (
            <div className="advanced-search-buttons">
                <button onClick={onAddSearchField} className="icon-button">
                    <svg className="add-field">
                        <use xlinkHref="#icon-add"></use>
                    </svg>
                    {addSearchFieldLabel}
                </button>
                <PrimaryButton buttonText={searchLabel} onClick={onSearch}/>
            </div>
        )
    }
}